export default function Index() {
  return (
    <div>
      <div className="divider mt-10">
        <h1>Announcements</h1>
      </div>
    </div>
  );
}